import { render } from "./TownClerks.vue?vue&type=template&id=db2e0218&scoped=true"
import script from "./TownClerks.vue?vue&type=script&lang=js"
export * from "./TownClerks.vue?vue&type=script&lang=js"

import "./TownClerks.vue?vue&type=style&index=0&id=db2e0218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db2e0218"]])

export default __exports__